/***********************
 * CHART TOOLS
 ************************/

const basicToolsDownloadZoom = {
  download: true,
  selection: true,
  zoom: true,
  zoomin: true,
  zoomout: true,
  pan: true,
  reset: true,
  customIcons: [],
}
const historyToolsDownloadZoom = {
  download: true,
  selection: false,
  zoom: false,
  zoomin: false,
  zoomout: false,
  pan: false,
  reset: false,
  customIcons: [],
}

export { basicToolsDownloadZoom, historyToolsDownloadZoom }
